<app-document-upload
	(uploadDocs)="uploadDocuments($event)"
	(deleteDoc)="deleteDocument($event)"
	[isUploading]="uploading"
	[uploadedDocs]="uploadedDocs">
</app-document-upload>